<template>
    <div class="flex flex-column align-center balance-container">
        <div class="flex flex-column align-center">
          <strong v-show="!hasBalance" class="balance-title">{{ $t('balanceLimit') }}</strong>
          <strong v-show="isProfessional" class="balance-title">{{ $t('isProfessional') }}</strong>
          <strong v-show="hasBalance" class="balance-subtitle">{{ $t('balanceAdd') }}</strong>
          <span>{{ $t('balanceLimitMessage') }}</span>
        </div>
        <div class="d-flex flex-row justify-space-between mt-12">
          <v-btn
              @click="goToConsumptions"
              large
              elevation="0"
              dark
              color="#8498AC"
              rounded
              style="border-radius: 10px;"
              class="mx-2 button"><h4>{{ $t('seeConsumptions') }}</h4>
          </v-btn>
          <v-btn
              v-if="!isProfessional"
              @click="upgrade"
              large
              elevation="0"
              dark
              color="#00CFDF"
              rounded
              style="border-radius: 10px;"
              class="mx-2 button">
              <h4>{{ $t('upgradeToProButton') }}</h4>
          </v-btn>
          <v-btn
              @click="addBalance"
              large
              elevation="0"
              dark
              color="#0FAEF6"
              rounded
              style="border-radius: 10px;"
              class="mx-2 button"><h4>{{ $t('topUp') }}</h4>
          </v-btn>
        </div>
    </div>
</template>

<script>
import link from '@/utils/links'
import { EventBus } from '@/eventBus'
import BillingValidations from '@/components/configuration/Billing/BillingValidations'

export default {
  name: 'StageLimitBalance',
  computed: {
    hasBalance () {
      return BillingValidations.hasBalance(true)
    },
    isProfessional () {
      return BillingValidations.isProfessional()
    }
  },
  methods: {
    goToConsumptions () {
      this.$emit('billing-stage-close')
      this.$router.push(link.billingConfigs)
    },
    upgrade () {
      EventBus.$emit('upgrade-to-pro')
    },
    addBalance () {
      this.$emit('billing-stage-credit')
      EventBus.$emit('billing:update-credit-card', true)
    }
  }
}
</script>

<style scoped lang="scss">
.balance-container {
  font-family: 'Montserrat';
}
.balance-title {
  font-size: 40px;
}

.balance-subtitle {
  font-size: 20px;
  margin-bottom: 10px;
}
.button {
  text-transform: none !important;
  letter-spacing: 0;
  font-weight: 700;
}
</style>
